import { useEffect, useState } from 'react'

interface DeviceInfo {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

function DeviceDetect(): DeviceInfo {
  const mobileRegex =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i
  const tabletRegex = /iPad|Android(?!.*Mobile)/i

  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  })

  useEffect(() => {
    const userAgent =
      typeof navigator === 'undefined' ? '' : navigator.userAgent

    const isMobile = mobileRegex.test(userAgent)
    const isTablet = tabletRegex.test(userAgent)
    const isDesktop = !isMobile && !isTablet

    setDeviceInfo({ isMobile, isTablet, isDesktop })
  }, [])

  return deviceInfo
}

export default DeviceDetect
